/**
 * <AccountFormCardSkeleton> — la forme d'une carte de champs pendant son chargement.
 *
 * Une carte, et par champ son intitulé puis sa boîte. Les pages de formulaire du compte en posent
 * une par carte de leur formulaire.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { TEXT_INPUT_HEIGHT } from "../../atoms/TextInput/TextInput"
import { Card } from "../../molecules/Card"

/** Des intitulés de longueurs différentes, comme ceux d'un vrai formulaire. */
const LABEL_WIDTHS = [90, 60, 170, 120, 140, 100]

export type AccountFormCardSkeletonProps = {
    /** Nombre de champs montrés. */
    fields: number
}

export function AccountFormCardSkeleton(props: AccountFormCardSkeletonProps) {
    return (
        <Card p="4">
            <Stack gap="3">
                {Array.from({ length: props.fields }, (_, index) => (
                    <Stack key={index} gap="1">
                        <Skeleton textSize="text-base" width={LABEL_WIDTHS[index % LABEL_WIDTHS.length]} />
                        <Skeleton shape="block" height={TEXT_INPUT_HEIGHT} radius="md" />
                    </Stack>
                ))}
            </Stack>
        </Card>
    )
}
